import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import type { LocalizationService } from '~/api/services/types'
import type { LocalizationDto, SupportedLocale } from '~/types/localization'
import type { StringObject } from '~/types/common'

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): LocalizationService => {
  return {
    getAllLocalizations: async (): Promise<LocalizationDto[]> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.LOCALIZATIONS_GET_ALL)
      return await client<LocalizationDto[]>(url, { method, headers, body })
    },

    getLocalizationsByKey: async (key: string): Promise<LocalizationDto> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.LOCALIZATIONS_GET_BY_KEY, {
        params: { name_localized_key: key }
      })
      return await client<LocalizationDto>(url, { method, headers, body })
    },

    getLocalizationsByLang: async (langCode: SupportedLocale): Promise<StringObject> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.LOCALIZATIONS_GET_BY_LANG, {
        params: { iso_lang_code: langCode }
      })
      return await client<Record<string, string>>(url, { method, headers, body })
    },

    createLocalization: async (data: LocalizationDto): Promise<void> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.LOCALIZATIONS_CREATE, {}, data)
      return await client<undefined>(url, { method, headers, body })
    },

    updateLocalization: async (key: string, data: LocalizationDto): Promise<void> => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.LOCALIZATIONS_UPDATE,
        { params: { name_localized_key: key } },
        data
      )
      return await client<undefined>(url, { method, headers, body })
    },

    deleteLocalization: async (key: string): Promise<void> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.LOCALIZATIONS_DELETE, {
        params: { name_localized_key: key }
      })
      return await client<undefined>(url, { method, headers, body })
    }
  }
}
